import React from "react";
import { Link } from "react-router-dom";
import classes from "./ProductThumbNailGroup.module.scss";
import ProductThumbNail from "../ProductThumbNail/ProductThumbNail";
import thumbNailHeadPhones from "../../assets/shared/desktop/image-category-thumbnail-headphones.png";
import thumbNailSpeakers from "../../assets/shared/desktop/image-category-thumbnail-speakers.png";
import thumbNailEarPhones from "../../assets/shared/desktop/image-category-thumbnail-earphones.png";

const ProductThumbNailGroup = ({ thumbNailURL, productNameShop }) => {
  return (
    <section className={`${classes.container} ${classes.product_items}`}>
      <ProductThumbNail
        thumbNailImgURL={thumbNailHeadPhones}
        shopProdName={"Headphones"}
        linkPath={"/headphones"}
      />
      <ProductThumbNail
        thumbNailImgURL={thumbNailSpeakers}
        shopProdName={"Speakers"}
        linkPath={"/speakers"}
      />
      <ProductThumbNail
        thumbNailImgURL={thumbNailEarPhones}
        shopProdName={"Earphones"}
        linkPath={"/earphones"}
      />
    </section>
  );
};

export default ProductThumbNailGroup;
